<template>
	<div class="mainpageMobile">
		<section class="mainView">
			<div class="heroContent">
				<h1 class="juxiuTitle">
					<img src="/img/systitle-mobile.svg" alt="数智治理与智慧软件解决方案服务商" />
				</h1>
				<div class="heroStats" aria-label="聚秀科技服务数据">
					<div class="heroStat">
						<span class="statValue">10<span class="statUnit statPlus">+</span></span>
						<span class="statLabel">年专业领域</span>
					</div>
					<span class="statDivider" aria-hidden="true"></span>
					<div class="heroStat">
						<span class="statValue">4<span class="statUnit">w+</span></span>
						<span class="statLabel">合作用户</span>
					</div>
				</div>
			</div>
		</section>

		<section class="businessInfo">
			<div class="business_title">
				<div class="title">1+N：业务发展方向</div>
				<div class="subtext">多跨融合 智慧治理</div>
			</div>
			<div class="jxsmartClound">
				<div class="smartName">聚秀数智云</div>
			</div>
			<div class="smartBg" aria-label="聚秀数智云业务领域">
				<button
					v-for="(item, index) in businessArr"
					:key="item.name"
					type="button"
					:class="['business_item', `business_item-${index + 1}`]"
					@click="goToBusiness(item.path)"
				>{{ item.name }}</button>
			</div>
		</section>

		<section class="applicationCases">
			<div class="business_title">
				<div class="title">应用案例</div>
				<div class="subtext">服务的用户遍布全国</div>
			</div>
			<van-swipe ref="caseSwipe" class="caseSwipe" :autoplay="3000" :show-indicators="false" @change="onCaseChange">
				<van-swipe-item v-for="(page, pageIndex) in applicationCasePages" :key="pageIndex" class="casePage">
					<div class="caseGrid">
						<router-link
							v-for="item in page"
							:key="item.name"
							class="caseCard"
							:to="{ path: '/caseDetails', query: { id: item.id, title: item.name } }"
							:aria-label="`查看${item.name}案例详情`"
						>
							<div class="caseImageWrap">
								<img class="caseImage" :src="item.image" :alt="item.name" loading="lazy" @error="useCaseFallback($event, item.fallback)">
							</div>
							<div class="caseContent">
								<div class="caseName">{{ item.name }}</div>
								<div class="caseLine"></div>
								<span class="caseCategory">{{ item.category }}</span>
							</div>
						</router-link>
					</div>
				</van-swipe-item>
			</van-swipe>
			<div class="indicators caseIndicators">
				<button
					v-for="(page, index) in applicationCasePages"
					:key="index"
					type="button"
					:class="{ active: caseCurrent === index }"
					:aria-label="`查看第${index + 1}页应用案例`"
					@click="changeCasePage(index)"
				></button>
			</div>
		</section>

		<section class="advantage">
			<div class="business_title">
				<div class="title">万千客户的信任与选择</div>
				<div class="subtext">全国各省市布局，助力驱动数字政府转型</div>
			</div>
			<div class="customerGroups" role="list" aria-label="合作客户">
				<div
					v-for="group in customerGroups"
					:key="group.id"
					:class="['customerGroup', { 'customerGroup--wide': group.columns === 2 }]"
					role="listitem"
				>
					<div class="customerItems" role="list">
						<div v-for="item in group.items" :key="item" class="customerItem" role="listitem">{{ item }}</div>
					</div>
				</div>
			</div>
		</section>

		<section class="thenews">
			<div class="business_title">
				<div class="title">资讯动态</div>
				<div class="subtext">关注聚秀发展，聚焦行业动态</div>
			</div>
			<div class="content">
				<van-swipe ref="newsSwipe" :autoplay="3000" :show-indicators="false" @change="onChange" class="swipe">
					<van-swipe-item
						v-for="(item, index) in newsArr"
						:key="index"
						class="swipeItem"
						@click="onCardClick(item)"
					>
						<img class="itemPic" :src="require('/public/img/dynamic/' + item.img)" :alt="item.title" loading="lazy">
						<div class="newsInfo">
							<div class="newsDate">{{ item.time }}</div>
							<div :class="['newsTitle', { active: current === index }]">{{ item.title }}</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="indicators">
					<button
						v-for="(item, index) in newsArr"
						:key="index"
						type="button"
						:class="{ active: current === index }"
						:aria-label="`查看第${index + 1}条资讯`"
						@click="changeItem(index)"
					></button>
				</div>
			</div>
			<button class="moreButton" type="button" @click="gotoMore">查看更多</button>
		</section>
	</div>
</template>

<script>
import { micData } from '@/views/dynamic/micData'

export default {
	data(){
		return {
			current: 0,
			caseCurrent: 0,
			businessArr: [
				{ name: '智慧国资', path: '/stateOwnedAssets' },
				{ name: '智慧国企', path: '/stateOwnedEnterprise' },
				{ name: '资产云', path: '/assetCloud' },
				{ name: '人工智能', path: '/ai' },
				{ name: '智慧监管', path: '/intelligentSupervision' },
				{ name: '智慧好管家', path: '/goodHousekeeper' }
			],
			applicationCases: [
				{ id: 26, name: '顺义区国资委', category: '智慧国资', image: 'http://minicdn.hzjuxiu.com/juxiu/case-assets/case-state-assets-shunyi.webp', fallback: require('@/assets/case-shunyi.png') },
				{ id: 22, name: '温州市国资委', category: '智慧国资', image: 'http://minicdn.hzjuxiu.com/juxiu/case-assets/case-state-assets-wenzhou.webp', fallback: require('@/assets/case-wenzhou.png') },
				{ id: 21, name: '杭州市国资委', category: '智慧国资', image: 'http://minicdn.hzjuxiu.com/juxiu/case-assets/case-state-assets-hangzhou.webp', fallback: require('@/assets/case-hangzhou.png') },
				{ id: 24, name: '舟山市国资委', category: '智慧国资', image: 'http://minicdn.hzjuxiu.com/juxiu/case-assets/case-state-assets-zhoushan.webp', fallback: require('@/assets/case-zhoushan.png') },
				{ id: 23, name: '衢州市国资委(在建)', category: '智慧国资', image: 'http://minicdn.hzjuxiu.com/juxiu/case-assets/case-state-assets-quzhou.webp', fallback: require('@/assets/case-quzhou.png') }
			],
			customerGroups: [
				{
					id: 'city-assets',
					columns: 1,
					items: ['杭州市国资委', '温州市国资委', '台州市国资委', '湖州市国资委', '衢州市国资委', '...']
				},
				{
					id: 'district-assets',
					columns: 2,
					items: [
						'西湖区国资办', '拱墅区国资办',
						'萧山区国资办', '余杭区国资办',
						'钱塘区国资办', '北仑区国资中心',
						'乐清市国资办', '鹿城区国资办',
						'温岭市国资办', '安吉县国资办',
						'定海区国资办', '...'
					]
				},
				{
					id: 'investment-groups',
					columns: 1,
					items: ['东阳国投集团', '临海国投', '滨海新区管委会']
				},
				{
					id: 'regional-assets',
					columns: 2,
					items: ['顺义区国资委', '房山区国资委', '萍乡市国资委', '望城区国资办', '宁乡市国资办', '...']
				}
			],
			newsArr: []
		}
	},
	computed: {
		applicationCasePages(){
			return [
				this.applicationCases.slice(0, 2),
				this.applicationCases.slice(2, 4),
				this.applicationCases.slice(4, 5)
			]
		}
	},
	mounted(){
		this.newsArr = micData.slice(0, 3)
	},
	methods: {
		useCaseFallback(event, fallback){
			if (event.target.dataset.fallbackUsed) return
			event.target.dataset.fallbackUsed = 'true'
			event.target.src = fallback
		},
		onCaseChange(index){
			this.caseCurrent = index
		},
		changeCasePage(index){
			this.caseCurrent = index
			this.$refs.caseSwipe.swipeTo(index)
		},
		goToBusiness(path){
			this.$router.push(path)
		},
		gotoMore(){
			this.$router.push('/informationDynamic')
			this.$store.commit('saveIdx', 8)
		},
		onCardClick(item){
			window.open(item.url)
		},
		onChange(index){
			this.current = index
		},
		changeItem(index){
			this.current = index
			this.$refs.newsSwipe.swipeTo(index)
		}
	}
}
</script>

<style lang="scss" scoped>
.mainpageMobile{
	width: 100%;
	.business_title{
		text-align: center;
		.title{
			font-size: 32px;
			font-family: Source Han Sans CN Medium;
			font-weight: 600;
			color: #333333;
			line-height: 45px;
		}
		.subtext{
			padding-top: 11px;
			font-size: 18px;
			font-family: Source Han Sans CN Normal;
			font-weight: 400;
			color: #666666;
			line-height: 25px;
		}
	}
	.mainView{
		box-sizing: border-box;
		width: 100%;
		height: 360px;
		position: relative;
		overflow: hidden;
		background: url('~@/assets/home-hero-city-2.png') right center / auto 100% no-repeat;
		text-align: left;
		.heroEllipse{
			position: absolute;
			display: block;
		}
		.heroEllipseSmall{
			top: 56px;
			left: 53%;
			width: 24px;
			height: 24px;
		}
		.heroEllipseMedium{
			top: 265px;
			left: 35%;
			width: 47px;
			height: 49px;
		}
		.heroEllipseLarge{
			top: 112px;
			right: 14%;
			width: 76px;
			height: 78px;
		}
		.heroContent{
			position: relative;
			z-index: 1;
			box-sizing: border-box;
			width: 100%;
			height: 100%;
			padding: 104px 40px 0;
		}
		.juxiuTitle{
			max-width: 620px;
			margin: 0;
			font-family: Source Han Sans CN Medium;
			font-size: 48px;
			font-weight: bold;
			color: #333131;
			line-height: 62px;
			letter-spacing: 3px;
			img {
				max-width: 100%;
			}
		}
		.heroStats{
			display: flex;
			align-items: center;
			margin-top: 42px;
		}
		.heroStat{
			display: flex;
			align-items: baseline;
			white-space: nowrap;
		}
		.statValue{
			font-family: PingFangSC, 'PingFang SC', sans-serif;
			font-size: 44px;
			font-weight: 600;
			line-height: 56px;
			color: #FF4A00;
			background: linear-gradient(0deg, #FF4A00 0%, #FF7C16 100%);
			-webkit-background-clip: text;
			background-clip: text;
			-webkit-text-fill-color: transparent;
		}
		.statUnit{
			margin-left: 2px;
			font-size: 20px;
			line-height: 28px;
		}
		.statPlus{
			margin-left: 0;
			font-size: 28px;
		}
		.statLabel{
			margin-left: 10px;
			font-size: 16px;
			font-weight: 500;
			color: #333333;
			line-height: 22px;
		}
		.statDivider{
			width: 1px;
			height: 44px;
			margin: 0 34px;
			background: rgba(105, 105, 105, 0.24);
		}
	}
	.businessInfo{
		padding-top: 45px;
		width: 100%;
		height: 500px;
		position: relative;
		display: flex;
		justify-content: center;
		.business_title{
			.title{
				font-size: 24px;
				font-family: Source Han Sans CN Medium;
				font-weight: 600;
				color: #333333;
				line-height: 33px;
			}
			.subtext{
				padding-top: 11px;
				font-size: 16px;
				font-family: Source Han Sans CN Normal;
				font-weight: 400;
				color: #666666;
				line-height: 22px;
			}
		}
		.jxsmartClound{
			position: absolute;
			top: 192px;
			left: calc(50% - 298px);
			width: 617px;
			height: 230px;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			background: url('/public/imgmobile/jxszy.png');
			background-size: 100% 100%;
			.smartName{
				font-size: 24px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				line-height: 33px;
				margin-bottom: 65px;
			}
		}
		.smartBg{
			.business_item{
				cursor: pointer;
				width: 180px;
				height: 44px;
				display: flex;
				padding: 0 0 4px 54px;
				align-items: center;
				border: 0;
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				line-height: 25px;
				text-align: left;
				background: url('/public/img/businessBlock.png');
				background-size: 100% 100%;
				position: absolute;
			}
			.business_item-1{ top: 240px; left: 67px; }
			.business_item-2{ top: 320px; left: 22px; }
			.business_item-3{ top: 394px; left: 150px; }
			.business_item-4{ top: 394px; left: 428px; }
			.business_item-5{ top: 320px; left: 556px; }
			.business_item-6{ top: 240px; left: 518px; }
		}
	}
	.applicationCases{
		box-sizing: border-box;
		width: 100%;
		padding: 60px 40px 72px;
		background: #F4F6F8;
		.caseSwipe{
			margin-top: 42px;
			margin-right: -12px;
			margin-left: -12px;

			.casePage{
				box-sizing: border-box;
				padding: 0 12px;
			}
		}
		.caseGrid{
			display: grid;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 24px;
		}
		.caseCard{
			min-width: 0;
			overflow: hidden;
			background: #FFFFFF;
			text-align: left;
			text-decoration: none;
		}
		.caseImageWrap{
			overflow: hidden;
			aspect-ratio: 2 / 1;
		}
		.caseImage{
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.caseContent{
			box-sizing: border-box;
			padding: 20px 16px 24px;
		}
		.caseName{
			overflow: hidden;
			font-size: 16px;
			font-weight: 600;
			color: #333333;
			line-height: 22px;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.caseLine{
			height: 1px;
			margin-top: 16px;
			border-top: 1px solid rgba(212, 212, 212, 0.5);
		}
		.caseCategory{
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 64px;
			height: 24px;
			margin-top: 12px;
			border-radius: 4px;
			background: rgba(255, 169, 43, 0.15);
			font-size: 12px;
			color: #FFA92B;
			line-height: 24px;
		}
		.caseIndicators{
			margin-top: 24px;
		}
	}
	.advantage{
		box-sizing: border-box;
		width: 100%;
		padding: 64px 66px;
		background: url('~@/assets/home-advantage-mobile-bg.png') center / 100% 100% no-repeat;
		.customerGroups{
			display: grid;
			grid-template-columns: 204px minmax(0, 1fr);
			column-gap: 40px;
			row-gap: 40px;
			margin-top: 56px;
		}
		.customerGroup{
			box-sizing: border-box;
			padding: 20px 24px;
			border-radius: 12px;
			background: rgba(255, 255, 255, 0.82);
			box-shadow: inset 0 0 0 1px rgba(255, 169, 43, 0.34);
		}
		.customerItems{
			display: grid;
			grid-template-columns: 1fr;
			gap: 20px;
		}
		.customerGroup--wide .customerItems{
			grid-template-columns: repeat(2, minmax(0, 1fr));
			column-gap: 16px;
		}
		.customerItem{
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			height: 52px;
			border-radius: 6px;
			background: rgba(255, 240, 228, 0.88);
			font-size: 16px;
			font-weight: 500;
			color: #FF5E2C;
			line-height: 22px;
			white-space: nowrap;
		}
	}
	.thenews{
		box-sizing: border-box;
		width: 100%;
		padding: 60px 40px 80px;
		.content{
			margin-top: 42px;
		}
		.swipe{
			height: 470px;
		}
		.swipeItem{
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: left;
		}
		.itemPic{
			display: block;
			width: 100%;
			height: 340px;
			object-fit: cover;
		}
		.newsInfo{
			width: 100%;
			padding-top: 15px;
		}
		.newsDate{
			font-size: 14px;
			font-weight: 400;
			color: #666666;
			line-height: 20px;
		}
		.newsTitle{
			margin-top: 12px;
			overflow: hidden;
			font-size: 16px;
			font-weight: 600;
			color: #333333;
			line-height: 24px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			&.active{
				color: #FF795B;
			}
		}
		.moreButton{
			display: block;
			width: 144px;
			height: 60px;
			margin: 44px 0 0 auto;
			padding: 0;
			border: 0;
			background: url('/public/img/morebtnbg.png') center / 100% 100% no-repeat;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 22px;
		}
	}
	.indicators{
		display: flex;
		justify-content: center;
		gap: 4px;
		margin-top: 24px;
		button{
			width: 44px;
			height: 44px;
			padding: 0;
			border: 0;
			position: relative;
			background: transparent;
			&::after{
				content: '';
				position: absolute;
				top: 50%;
				left: 50%;
				width: 12px;
				height: 12px;
				border-radius: 50%;
				background: linear-gradient(90deg, #FF795B 0%, #FF8E36 100%);
				opacity: 0.4;
				transform: translate(-50%, -50%);
			}
			&.active::after{
				opacity: 1;
			}
		}
	}
}
</style>
